export const figure12a = {
chart: {
  zoomType: 'xy',
  animation: false,
  marginTop: 50,
  marginLeft: 100,
  marginBottom: 175,
  plotBackgroundColor: null,
  plotBorderWidth: null,
  plotShadow: false,
  type: 'column',
  height: '400px',
  backgroundColor: 'rgba(255, 255, 255, 0.0)',
  style: {
    fontFamily: 'Montserrat'
  }
},
title: {
    text: null
},
subtitle: {
    text: null
},
credits: {
  enabled: false
},
legend: {
  enabled: false,
}, 
exporting: {
  enabled: false
},
colors: ['#5b9bd5', '#ed7d31'],
xAxis: {
    categories: [
        "Burkina Faso 2014",
        "Etiopía 2014",
        "Etiopía 2016",
        "India 2005",
        "India 2012",
        "Malawi 2011",
        "Malawi 2013",
        "Malawi 2017",
        "Malí 2014",
        "Malí 2017",
        "Níger 2011",
        "Níger 2014",
        "Nigeria 2013",
        "Nigeria 2016",
        "Nigeria 2019",
        "República Unida de Tanzanía 2009",
        "República Unida de Tanzanía 2011",
        "República Unida de Tanzanía 2013",
        "Uganda 2010",
        "Uganda 2011",
        "Uganda 2012",
        "Uganda 2014",
        "Uganda 2016",
],
    crosshair: true
},
yAxis: {
    max: 16,
    min: 0,
    tickInterval: 2,
    labels: {
        format: '{value}%',
        formatter: function () {
            return this.value + ".00";
        },
    },
    title: {
        text: null
    }
},
tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true
},
plotOptions: {
    column: {
        pointPadding: 0.2,
        borderWidth: 0
    }
},
series: [
{
    name: 'Hogar encabezado por un hombre',
    data: [
        3.80,
        4.29,
        4.44,
        5.47,
        8.05,
        5.05,
        6.79,
        5.27,
        7.80,
        13.68,
        5.13,
        5.59,
        12.17,
        4.03,
        5.18,
        3.42,
        4.32,
        3.68,
        4.90,
        3.87,
        4.59,
        3.76,
        3.96
      ]

},
{
    name: 'Hogar encabezado por una mujer',
    data: [
        2.83,
        3.86,
        5.35,
        6.76,
        8.25,
        4.53,
        6.75,
        4.78,
        9.33,
        7.97,
        3.16,
        5.56,
        7.96,
        3.47,
        3.31,
        3.39,
        4.38,
        3.26,
        4.38,
        3.54,
        3.71,
        4.57,
        3.47        
    ]
}
]
}